import App from "./App.svelte";

const app = new App({
  target: document.getElementById("openacr-editor"),
});

export default app;
